'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'

import { useLocation } from '@/components/providers/LocationProvider'
import { usePriceSources } from '@/hooks/usePriceSources'
import { useReduxSelector } from '@/store/hooks'
import { initializeGA, trackEvent, trackPageview } from '@/utils/analyticsUtil'

export const GoogleAnalyticsInitializer = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const authStatus = useReduxSelector((s) => s.user.status)
  const { country } = useLocation()
  const priceSources = usePriceSources()
  const lastPageRef = useRef<string | null>(null)
  const lastSourcesRef = useRef<string | null>(null)

  useEffect(() => {
    initializeGA()
  }, [])

  useEffect(() => {
    if (authStatus === 'loading') return

    const search = searchParams.toString()
    const page = search ? `${pathname}?${search}` : pathname
    if (lastPageRef.current === page) return

    lastPageRef.current = page
    trackPageview(page)
  }, [authStatus, pathname, searchParams])

  useEffect(() => {
    if (authStatus === 'loading') return

    const key = `${country ?? ''}|${priceSources.join(',')}`
    if (lastSourcesRef.current === key) return

    lastSourcesRef.current = key
    priceSources.forEach((source) =>
      trackEvent({
        action: 'init_price_source',
        category: 'pricing',
        label: `country:${country}|source:${source}`,
        nonInteraction: true,
      }),
    )
  }, [authStatus, country, priceSources])

  return null
}
